import React, { useEffect, useState, useRef } from "react";
import storia from "../../assets/Foto per transizione/P1088351.jpg";

const Sectionhome1 = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(".moving-paragraph"); // Seleziona tutti gli elementi con la classe moving-paragraph

    // Verifica che ci siano elementi da osservare
    if (elements.length > 0) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");
            } /*  else {
                  entry.target.classList.remove("visible");
                } */
          });
        },
        {
          threshold: 0.3, // La visibilità minima dell'elemento per attivare la transizione
        }
      );

      // Osserva ogni elemento con la classe 'moving-paragraph'
      elements.forEach((element) => observer.observe(element));

      // Cleanup dell'observer al momento dello smontaggio
      return () => observer.disconnect();
    }
  }, []); // Solo al primo render
  return (
    <div
      id="identità"
      className="bg-[#7f8473] gap-x-[10em] flex flex-col md:flex-row items-center justify-center min-h-[60vh] p-8 text-white"
    >
      {/* Left Section - Text */}
      <div className="md:w-1/2 text-center md:text-center flex flex-col items-center md:items-center moving-paragraph">
        <h1 className="text-4xl md:text-5xl font-bold text-white">IDENTITÀ</h1>
        <h2 className="italic text-lg md:text-xl mt-2 font-bold">
          Tenute Colonico
        </h2>
        <p className="mt-4 text-lg md:text-xl max-w-lg md:max-w-xl">
          Tenute Colonico produce olio Extra Vergine di Oliva di categoria
          superiore. <br /> L'azienda nasce per volontà dei fratelli Mario e
          Alessandro Colonico con l'obiettivo di valorizzare la coltura e la
          cultura dell'ulivo nel cuore dell'Abruzzo montano.
          <br /> Tenute Colonico custodisce tradizioni secolari scolpite nel
          legno degli ulivi ed eleva la qualità degli oli in prodotti unici e
          autentici.
        </p>
      </div>

      {/* Right Section - Single Image */}
      <div className="md:w-1/4 flex justify-center mt-6 md:mt-0  moving-paragraph">
        <div className="w-[100%]">
          <img
            src={storia}
            alt="Piatto raffinato"
            className="w-full h-auto rounded-lg "
          />
        </div>
      </div>
    </div>
  );
};

export default Sectionhome1;
